export class Company {
  constructor(
    public hash: string,
    public name: string,
    public email: string,
    public minEmployees: number,
    public maxEmployees: number,
    public companyRegistrationNumber: string = null,
    public address: string = null,
    public province: string = null,
    public postalCode: string = null
  ) { }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/company.ts